import {
  EventEmailTrigger,
  EventEmailTemplate,
  GetMembershipDetailsOutput,
} from '@graphql/__generated/graphql'
import { EventCreation } from '@libs/CreateEventContext'

export const SCHEDULED_EMAIL_TRIGGER = EventEmailTrigger.Scheduled

export type EmailTemplateListItem = EventEmailTemplate & {
  editIndex?: number
  originalTitle?: string
  legacyScheduleTimestamp?: string
}

export interface IEmailBuilder {
  enablePreview: boolean
  template?: Partial<EmailTemplateListItem>
  onSubmit?: (template: EmailTemplateListItem) => void
  setError?: (message: string, testId: string) => void
  decorators?: object[]
  data?: Partial<EventCreation | GetMembershipDetailsOutput>
  type?: 'event' | 'membership'
  cacheScopeId?: string | null
}
